export const localeEs = {
    primary: 'Primario',
    secundary: 'Secundario',
    tertiary: 'Terciario',
    warning: 'Peligro',
    default_text: 'Defecto',
    withicon: 'Con Icono',
    option_one: "Opcion uno",
    option_two: "Opcion dos",
    option_three: "Opcion tres",
    option_four: "Opcion cuartro",
    option_unique: 'Opcion unica',
    required_message: 'Este campo es requerido',
    username_label: 'Usuario',
    password_label: 'Contraseña',
    subscription_label: 'Suscribirse',
    sex_label: "Sexo",
    shopping_list_label: "Lista de mercado",
    submit_label: "Enviar",
    report_setup: 'Configuración del Reporte',
    report_option: 'Opciones del Reporte',
    close: 'Cerrar',
    clear: 'Borrar',
    clear_all: 'Borrar Todo',
    title_label: 'Titulo label',
    placeholder_text: 'Texto de ayuda',
    assistive_text: 'Texto asistido',
    information_fied: 'Informacion sobre este campo',
    required_title_info: 'Input requerido usado desde un form',
    only_integer_number: 'Solo se permiten números enteros',
    decimal_number: 'Números decimales permitidos',
    select_all: 'Seleccionar todo',
    on: 'Encendido',
    off: 'Apagado',
    yes: 'SI',
    no: 'NO',
    toggle: 'Alternar',
    tab_one: 'Pestaña 1',
    tab_two: 'Pestaña 2',
    tab_three: 'Pestaña 3',
    option_list: 'Lista de opciones',
    cancel: 'Cancelar',
    apply: 'Aplicar',
    upload: 'Cargar',
    finish_upload: 'Finalizar Carga',
    alertstabview_action: "Accion",
    alertstabview_summary: "Resumen",
    per_page: 'Por Pagina',
    previous: 'Anterior',
    next: 'Siguiente',
    alertstabview_severity: "Severidad",
    all: 'Todos',
    export_csv: "Exportar CSV",
    export_pdf: "Exportar PDF",
    export: 'Exportar',
    delete: 'Eliminar',
    add: 'Añadir',
    start: 'Inicio',
    end: 'Fin',
    set: 'Aplicar',
    select: 'Seleccionar',
    show_all: "Mostrar todo",
    collapse_to_ten: "Mostrar solo diez",
    reminder: "Recordatorio",
    due_now: "Vencido",
    scheduled: "Programado",
    past_due: "Atrasado",
    due: "Vencido",
    due_soon: "Prox a vencer",
    done: "Terminado",
    select_subscriber: "Selecciona un suscriptor",
    add_subscribers: "Adicionar suscriptores",
    fetching_more_list_items: "Cargando mas items...",
    filter: "Filtro",
    select_date: "Seleccionar fecha ",
    maintenance_status: "Estado de mantenimiento",
    services: "Servicios",
    drivers: "Conductores",
    today: "Hoy",
    yesterday: "Ayer",
    week: "Esta semana",
    last_week: "La semana pasada",
    this_month: "Este mes",
    last_month: "El mes pasado",
    quarter: "Este trimestre",
    last_quarter: "El trimestre pasado",
    tomorrow: "Mañana",
    next7days: "Próximos 7 Dias",
    next15days: "Próximos 15 Dias",
    nextMonth: "Próximo mes",
    next30Days: "Próximos 30 Dias",
    next90Days: "Próximos 90 Dias",
    custom: "Personalizado",
    last7days: "Hace 7 Dias",
    last30days: "Hace 30 Dias",
    advanced_filters: "Filtros avanzados",
    advanced_filter_options: "Opciones de filtros avanzados",
    attachments: 'archivos adjuntos',
    select_files: 'Seleccionar Archivo(s)',
    open_item: 'Abrir Item',
    lorem_ipsum: 'Ni tampoco hay nadie que ame, persiga y quiera alcanzar el dolor mismo porque sea dolor, sino porque a veces se dan las circunstancias de tal manera, que con esfuerzo y dolor puede obtenerse algún gran placer.',
    open_menu: 'Abrir Menu',
    select_timeframe: "Selecciona un intervalo de tiempo",
    same_time_or_after_validation: "Por favor complete los rangos de horas seleccionando la hora final mayor que la inicial.",
    change_column_order: "Cambiar orden de columna",
    linked: 'Vinculado',
    unlinked: 'No vinculado',
    assigned_to: 'Vinculado a:',
    select_temp_url: 'seleccionar esta imagen como avatar temporal',
    faces_linked_to: 'rostro(s) estan vinculados a',
    apply_lang: "Aplicar",
    faces_detele: 'Eliminar este rostro',
    draganddrop: 'Arrastre y suelte un archivo aquí o haga clic',
    selectAllTags: 'Seleccionar todos los tags',
    inactive: 'Inactivo',
    include_inactive_drivers: 'Incluir conductores inactivos'


}
